import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4813ef6d&scoped=true&class=full-height"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4813ef6d&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4813ef6d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813ef6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4813ef6d')) {
      api.createRecord('4813ef6d', component.options)
    } else {
      api.reload('4813ef6d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4813ef6d&scoped=true&class=full-height", function () {
      api.rerender('4813ef6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/agencyRecordReview/index.vue"
export default component.exports